import { create } from "zustand";
import AppUserProfile from "../assets/js/AppUserProfile";
import { GetApproverList } from "../services/TicketService";

const useApproverStore = create((set, get) => ({
  approvers: new Map(),
  isLoading: false,
  error: null,

  selectApprovers: new Map(),

  fetchApprovers: async () => {
    if (get().approvers.size > 0) {
      return;
    }

    set({ isLoading: true });
    try {
      const response = await GetApproverList({
        token: AppUserProfile.getData()["access_token"],
      });

      const groupedApprovers = new Map();
      response.data.users.forEach((user) => {
        if (!groupedApprovers.has(user.role_name)) {
          groupedApprovers.set(user.role_name, []);
        }
        groupedApprovers.get(user.role_name).push(user);
      });

      set({
        approvers: groupedApprovers,
        isLoading: false,
        error: null,
      });
    } catch (error) {
      set({
        error: error.message,
        isLoading: false,
      });
    }
  },

  setSelectApprover: ({ approver }) => {
    const approverMap =
      approver instanceof Map ? approver : new Map(Object.entries(approver));

    set(() => ({
      selectApprovers: approverMap,
    }));
  },

  findApproverInStore: (targetLevel, targetUserId) => {
    const state = get();
    if (!state.approvers) return null;

    const levelApprovers = state.approvers.get(targetLevel);
    if (!levelApprovers) return null;

    return levelApprovers.find((approver) => approver.id === targetUserId);
  },

  findApproverWithConfig: (ticketDetail) => {
    const state = get();

    if (!ticketDetail?.approvers) {
      return [];
    }

    const approverConfigs = [
      {
        sequence: (approver) =>
          approver.proposal_phase_sequence_no === 1 &&
          approver.claim_phase_sequence_no === 1 &&
          approver.accounting_phase_sequence_no === 1,
      },
      {
        sequence: (approver) =>
          approver.proposal_phase_sequence_no === 2 &&
          approver.claim_phase_sequence_no === 2,
      },
      {
        sequence: (approver) =>
          approver.proposal_phase_sequence_no === 3 &&
          approver.claim_phase_sequence_no === 3,
      },
      {
        sequence: (approver) => approver.management_phase_sequence_no === 1,
      },
      {
        sequence: (approver) => approver.management_phase_sequence_no === 2,
      },
    ];

    return approverConfigs
      .map((config) => {
        const foundApprover = ticketDetail.approvers.find(config.sequence);
        if (!foundApprover) return null;

        return state.findApproverInStore(
          foundApprover.level,
          foundApprover.user_id
        );
      })
      .filter(Boolean);
  },
}));

export default useApproverStore;
